// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 60868 ? "auth-suite-sdk" : chunkId) + "-" + {"18623":"d817e899225c90ba245a","44139":"6f106a0cc9959c05660b","60868":"38093af7953a1582898c","69699":"69da25b9cd7e8b6f1573","73588":"85c1bdf8779f9733e9b1","78566":"87f0c39bb271550e2d95","83227":"f2e63c0187a7939d27bb"}[chunkId] + ".min.js";
};